/**
 * Enrollment action constants
 * Used by backend to tell frontend what to display/do next
 */

export const ENROLLMENT_ACTIONS = {
  // User successfully enrolled
  ENROLLED: 'enrolled',

  // Show terms of service agreement (needs payment/coupon or agreement)
  SHOW_AGREEMENT: 'show_agreement',

  // Collect user info (name/password) for new Canvas users
  COLLECT_USER_INFO: 'collect_user_info',

  // User already enrolled (idempotent)
  ALREADY_ENROLLED: 'already_enrolled',

  // Canvas API error (temporary, user should retry)
  CANVAS_ERROR: 'canvas_error'
}
